import { connect } from 'react-redux';
import EventInfo from '../../components/eventInfo';

import { getJwtToken } from '../../reducers';

const mapStateToProps = state => ({
    jwtToken: getJwtToken(state)
});

export default connect(mapStateToProps)(EventInfo);



// WEBPACK FOOTER //
// ./src/containers/eventInfo/index.js